export var QueryDBRestoreDestinationType;
(function (QueryDBRestoreDestinationType) {
    QueryDBRestoreDestinationType["S3"] = "S3";
    QueryDBRestoreDestinationType["Gcs"] = "GCS";
    QueryDBRestoreDestinationType["StorageAccountContainer"] = "STORAGE_ACCOUNT_CONTAINER";
})(QueryDBRestoreDestinationType || (QueryDBRestoreDestinationType = {}));
